const modal = document.getElementById('videoModal');
const video = document.getElementById('modalVideo');
const closeBtn = modal.querySelector('.close');

document.querySelectorAll('.bubble').forEach(bubble => {
  bubble.addEventListener('click', () => {
    const videoSrc = bubble.dataset.video;
    if (!videoSrc) return;
    video.querySelector('source').src = videoSrc;
    video.load();
    modal.style.display = 'block';
    video.play();
  });
});

const closeModal = () => {
  modal.style.display = 'none';
  video.pause();
  video.currentTime = 0;
};

closeBtn.addEventListener('click', closeModal);

window.addEventListener('click', e => {
  if (e.target === modal) closeModal();
});

modal.style.display = 'none';

// Detect leaving fullscreen on iOS or other browsers
video.addEventListener('webkitendfullscreen', closeModal);
video.addEventListener('fullscreenchange', () => {
  if (!document.fullscreenElement) closeModal();
});
